import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);



const seedrandom = require('seedrandom');

const ChartRenderer = ({trackValues, tokenId}) => {
    const chartContainer = useRef(null);
    const [chart, setChart] = useState(null);
    const id = tokenId;
    const tokenValue = trackValues;

    useEffect(() => {
        const variableSets = [[32, 2, 32], [32, 2, 31], [32, 2, 30], [32, 2, 29], [32, 2, 28], [32, 2, 27], [32, 2, 26], [32, 2, 25], [32, 2, 24], [32, 2, 23], [32, 2, 22], [32, 2, 21], [32, 2, 20], [32, 2, 19], [32, 2, 18], [32, 2, 17], [32, 2, 16], [32, 2, 15], [32, 2, 14], [32, 2, 13], [32, 2, 12], [32, 2, 11], [32, 2, 10], [32, 2, 9], [32, 2, 8], [32, 2, 7], [32, 2, 6], [32, 2, 5], [32, 2, 4], [32, 2, 3], [32, 2, 2], [32, 2, 1], [32, 1, 32], [32, 1, 31], [32, 1, 30], [32, 1, 29], [32, 1, 28], [32, 1, 27], [32, 1, 26], [32, 1, 25], [32, 1, 24], [32, 1, 23], [32, 1, 22], [32, 1, 21], [32, 1, 20], [32, 1, 19], [32, 1, 18], [32, 1, 17], [32, 1, 16], [32, 1, 15], [32, 1, 14], [32, 1, 13], [32, 1, 12], [32, 1, 11], [32, 1, 10], [32, 1, 9], [32, 1, 8], [32, 1, 7], [32, 1, 6], [32, 1, 5], [32, 1, 4], [32, 1, 3], [32, 1, 2], [32, 1, 1], [32, 0, 32], [32, 0, 31], [32, 0, 30], [32, 0, 29], [32, 0, 28], [32, 0, 27], [32, 0, 26], [32, 0, 25], [32, 0, 24], [32, 0, 23], [32, 0, 22], [32, 0, 21], [32, 0, 20], [32, 0, 19], [32, 0, 18], [32, 0, 17], [32, 0, 16], [32, 0, 15], [32, 0, 14], [32, 0, 13], [32, 0, 12], [32, 0, 11], [32, 0, 10], [32, 0, 9], [32, 0, 8], [32, 0, 7], [32, 0, 6], [32, 0, 5], [32, 0, 4], [32, 0, 3], [32, 0, 2], [32, 0, 1], [64, 2, 32], [64, 2, 31], [64, 2, 30], [64, 2, 29], [64, 2, 28], [64, 2, 27], [64, 2, 26], [64, 2, 25], [64, 2, 24], [64, 2, 23], [64, 2, 22], [64, 2, 21], [64, 2, 20], [64, 2, 19], [64, 2, 18], [64, 2, 17], [64, 2, 16], [64, 2, 15], [64, 2, 14], [64, 2, 13], [64, 2, 12], [64, 2, 11], [64, 2, 10], [64, 2, 9], [64, 2, 8], [64, 2, 7], [64, 2, 6], [64, 2, 5], [64, 2, 4], [64, 2, 3], [64, 2, 2], [64, 2, 1], [64, 1, 32], [64, 1, 31], [64, 1, 30], [64, 1, 29], [64, 1, 28], [64, 1, 27], [64, 1, 26], [64, 1, 25], [64, 1, 24], [64, 1, 23], [64, 1, 22], [64, 1, 21], [64, 1, 20], [64, 1, 19], [64, 1, 18], [64, 1, 17], [64, 1, 16], [64, 1, 15], [64, 1, 14], [64, 1, 13], [64, 1, 12], [64, 1, 11], [64, 1, 10], [64, 1, 9], [64, 1, 8], [64, 1, 7], [64, 1, 6], [64, 1, 5], [64, 1, 4], [64, 1, 3], [64, 1, 2], [64, 1, 1], [64, 0, 32], [64, 0, 31], [64, 0, 30], [64, 0, 29], [64, 0, 28], [64, 0, 27], [64, 0, 26], [64, 0, 25], [64, 0, 24], [64, 0, 23], [64, 0, 22], [64, 0, 21], [64, 0, 20], [64, 0, 19], [64, 0, 18], [64, 0, 17], [64, 0, 16], [64, 0, 15], [64, 0, 14], [64, 0, 13], [64, 0, 12], [64, 0, 11], [64, 0, 10], [64, 0, 9], [64, 0, 8], [64, 0, 7], [64, 0, 6], [64, 0, 5], [64, 0, 4], [64, 0, 3], [64, 0, 2], [64, 0, 1], [128, 2, 32], [128, 2, 31], [128, 2, 30], [128, 2, 29], [128, 2, 28], [128, 2, 27], [128, 2, 26], [128, 2, 25], [128, 2, 24], [128, 2, 23], [128, 2, 22], [128, 2, 21], [128, 2, 20], [128, 2, 19], [128, 2, 18], [128, 2, 17], [128, 2, 16], [128, 2, 15], [128, 2, 14], [128, 2, 13], [128, 2, 12], [128, 2, 11], [128, 2, 10], [128, 2, 9], [128, 2, 8], [128, 2, 7], [128, 2, 6], [128, 2, 5], [128, 2, 4], [128, 2, 3], [128, 2, 2], [128, 2, 1], [128, 1, 32], [128, 1, 31], [128, 1, 30], [128, 1, 29], [128, 1, 28], [128, 1, 27], [128, 1, 26], [128, 1, 25], [128, 1, 24], [128, 1, 23], [128, 1, 22], [128, 1, 21], [128, 1, 20], [128, 1, 19], [128, 1, 18], [128, 1, 17], [128, 1, 16], [128, 1, 15], [128, 1, 14], [128, 1, 13], [128, 1, 12], [128, 1, 11], [128, 1, 10], [128, 1, 9], [128, 1, 8], [128, 1, 7], [128, 1, 6], [128, 1, 5], [128, 1, 4], [128, 1, 3], [128, 1, 2], [128, 1, 1], [128, 0, 32], [128, 0, 31], [128, 0, 30], [128, 0, 29], [128, 0, 28], [128, 0, 27], [128, 0, 26], [128, 0, 25], [128, 0, 24], [128, 0, 23], [128, 0, 22], [128, 0, 21], [128, 0, 20], [128, 0, 19], [128, 0, 18], [128, 0, 17], [128, 0, 16], [128, 0, 15], [128, 0, 14], [128, 0, 13], [128, 0, 12], [128, 0, 11], [128, 0, 10], [128, 0, 9], [128, 0, 8], [128, 0, 7], [128, 0, 6], [128, 0, 5], [128, 0, 4], [128, 0, 3], [128, 0, 2], [128, 0, 1]];

        function countSquares(gridSize, gridResolution, levelProgression, id) {
            function seededRandom(sd) {
                const rng = seedrandom(sd);
                return () => rng.quick();
            }

            const rngM = seededRandom(id);
            gridSize = gridSize === 128 ? 71 : gridSize === 64 ? 54 : gridSize;
            const mxSq = (levelProgression + 32) / 10;
            const sqrSR = (gridResolution + 1) / 10;
            const cellSize = 512 / gridSize;
            let squareCount = 0;
            const occupiedCells = new Array(gridSize).fill().map(() => new Array(gridSize).fill(false));
            for (let x = 0; x < gridSize; x++) {
                for (let y = 0; y < gridSize; y++) {
                    if (!occupiedCells[x][y]) {
                        let maxSize = 1;
                        while (
                            x + maxSize < gridSize &&
                            y + maxSize < gridSize &&
                            !occupiedCells
                                .slice(x, x + maxSize + 1)
                                .some((row) => row.slice(y, y + maxSize + 1).some((cell) => cell))
                        ) {
                            maxSize++;
                        }

                        let useBigSquare = rngM() < sqrSR;
                        if (useBigSquare) {
                            maxSize = Math.min(Math.floor(rngM() * rngM() * ((mxSq + 1) - 2 + 1)) + 2, maxSize);
                        } else {
                            maxSize = Math.min(Math.floor(rngM() * rngM() * (2 - 1 + 1)) + 1, maxSize);
                        }
                        const rectSize = cellSize * maxSize;
                        for (let i = x; i < x + rectSize / cellSize; i++) {
                            for (let j = y; j < y + rectSize / cellSize; j++) {
                                occupiedCells[i][j] = true;
                            }
                        }
                        squareCount++;
                    }
                }
            }
            return squareCount;
        }

        function updateChart() {
            const labels = []; // X-axis labels
            const squareCounts = []; // Y-axis data

            // Calculate square count for each variable set
            for (let i =0; i<variableSets.length; i++) {
                const [gridSize, gridResolution, levelProgression] = variableSets[i];
                const squareCount = countSquares(gridSize, gridResolution, levelProgression, id);
                squareCounts.push((Math.floor(((squareCount * 8) / 64) - 3) * 32));
                labels.push(`${gridSize} - ${gridResolution>1?'Low':gridResolution>0?'Medium':'High'} - ${levelProgression}`);
            }
            console.log(labels[tokenValue]);

            // Create chart
            if (!chart) {
                // Get canvas element
                const ctx = document.getElementById('chartRenderer').getContext('2d');

                const newChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: 'Characters',
                                data: squareCounts,
                                backgroundColor: 'rgba(0, 255, 0, 0.2)',
                                borderColor: 'rgba(0, 255, 0, 1)',
                                borderWidth: 1,
                                scales: {
                                    x: {
                                        ticks: {
                                            beginAtZero: true,
                                            fontColor: 'white', // Font color
                                            fontFamily: 'Andale Mono', // Font family
                                        }
                                    },
                                    y: {
                                        border: {
                                            display: true
                                        },
                                        ticks: {
                                            fontColor: 'white', // Font color
                                            fontFamily: 'Andale Mono', // Font family
                                        },
                                        display: true,
                                        drawTicks: true
                                    }
                                }
                            }]
                    },
                    options: {
                        plugins: {
                            legend:false,
                            annotation:{
                                annotations:{
                                    line1:{
                                        type:'line',
                                        xMin:labels[tokenValue],
                                        xMax:labels[tokenValue],
                                        borderColor:'#ff0000',
                                        borderWidth: 1
                                    },
                                    line2:{
                                        type:'line',
                                        yMin:squareCounts[tokenValue],
                                        yMax:squareCounts[tokenValue],
                                        borderColor:'#ff0000',
                                        borderWidth: 1
                                    },
                                    label:{
                                        type:'label',
                                        xValue : 50,
                                        yValue : squareCounts[tokenValue],
                                        backgroundColor : '#00000080',
                                        color: '#ff0000',
                                        content : squareCounts[tokenValue],
                                        font:{
                                            size:12
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
                setChart(newChart);
            } else {
                // Clear existing data
                chart.data.labels = labels;
                chart.data.datasets[0].data = squareCounts;
                chart.update();
            }
        }

        updateChart();


        return () => {
            
        };
    }, [trackValues]);

    return (
        <div className='tokenChart'>
            <canvas style={{backgroundColor: 'transparent'}} ref={chartContainer} id="chartRenderer" width="800" height="650"></canvas>
        </div>
    );
};

export default ChartRenderer;
